import { AccountRow } from "./types";

export function isRowAwaitingAiMapping(
    row: Pick<AccountRow, "kickAccountId" | "createNewAccount">,
): boolean {
    return !row.kickAccountId && !row.createNewAccount;
}

export function isRowShowingMappingLoading({
    row,
    isAccountsMappingRunning,
}: {
    row: Pick<AccountRow, "kickAccountId" | "createNewAccount">;
    isAccountsMappingRunning: boolean;
}): boolean {
    return isAccountsMappingRunning && isRowAwaitingAiMapping(row);
}
